/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { PaymentRequestMutation, PaymentRequestMutationVariables } from "@models/graphql";

const defaultPaymentRequestOptions: MutationHookOptions<PaymentRequestMutation, PaymentRequestMutationVariables> = {};

export const usePaymentRequest = (options?: MutationHookOptions<PaymentRequestMutation, PaymentRequestMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<PaymentRequestMutation, PaymentRequestMutationVariables>(
        GraphQLDocuments.paymentRequest
    );

    const paymentRequest = async (variables: PaymentRequestMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultPaymentRequestOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return { error: err };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        paymentRequest
    };
};
